<template>
  <SlotPanel class="text-base text-center font-sans my-4 py-12 px-12 h-full w-full lg:w-2/3">
    <h2>There are no shows for today.</h2>
    <span
      @click="goToNextPerformance"
      v-if="nextClosestPerformance"
      class="text-fg-link-primary cursor-pointer underline underline-offset-2"
    >
      The next show is {{ nextClosestPerformance.show.name }} on
      {{ dateLongStr(nextClosestPerformance.datetime) }} &rarr;
    </span>
    <span v-else> There are no more performances scheduled in the future. </span>
  </SlotPanel>
</template>

<script lang="ts">
import { mapState, mapStores } from 'pinia'
import { defineComponent } from 'vue'

import SlotPanel from '@/common/components/organisms/SlotPanel.vue'
import { StorePerformance } from '@/models'
import { usePerformanceStore } from '@/modules/performance/stores/PerformanceStore'
import { useSettingStore } from '@/stores/setting'
import { sortBy } from '@/utils/utils'

export default defineComponent({
  name: 'PerformanceNoShowAlert',
  components: { SlotPanel },
  props: {
    dateFilter: {
      type: String,
      required: true,
    },
  },
  emits: {
    // eslint-disable-next-line no-unused-vars
    'update:dateFilter': (queryDate: string) => true,
    // eslint-disable-next-line no-unused-vars
    switchPerformance: (performanceId: number) => true,
  },
  methods: {
    goToNextPerformance() {
      const newQueryDate = this.dateIsoStr(this.nextClosestPerformance!.datetime)
      this.$emit('update:dateFilter', newQueryDate)
      this.$emit('switchPerformance', this.nextClosestPerformance!.id)
    },
  },
  computed: {
    ...mapStores(usePerformanceStore, useSettingStore),
    ...mapState(useSettingStore, ['dateLongStr', 'dateIsoStr']),
    nextClosestPerformance(): StorePerformance | undefined {
      const performancesAfterQueryDate = this.performanceStore.performances.filter(
        obj => obj.date > this.dateFilter,
      )
      if (performancesAfterQueryDate.length === 0) return undefined
      return sortBy(performancesAfterQueryDate, 'datetime')[0] as StorePerformance | undefined
    },
  },
})
</script>
